
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/about-fhs-saudi",
      function () {
        return require("private-next-pages/sa/about-fhs-saudi.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/about-fhs-saudi"])
      });
    }
  